export default async (condition: boolean, timer = 200): Promise<void> => (
  new Promise((resolve) => {
    const interval = setInterval(() => {
      if (condition) {
        clearInterval(interval);
        resolve();
      }
    }, timer);
  })
);
